module.exports = __webpack_public_path__ + "img/2.08e9676a.png";